import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import UserSessionName from "../../components/userSession/UserSessionDetail/UserSessionName.tsx";
import {useLocationFormState} from "../../components/userSession/UserSessionForm/UserSessionUpdateForm";
import UserSessionUpdateFormProvider from "../../components/userSession/UserSessionForm/UserSessionUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserSessionUpdateEditPage = () => {
    
    useTitle(t`Update User Session`);

    const { userSessionId: id } = useParams();
    
    return (
        <Box data-testid="UserSession-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="UserSession-update-title"
                    >
                        <Trans>Edit User Session</Trans>:  <UserSessionName id={id}/>
                    </Typography>
                    <UserSessionUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default UserSessionUpdateEditPage;
